export default __webpack_public_path__ + "img/home-icon-active.567f3336.svg";